import * as XLSX from "xlsx";

export function downloadTransactionsXlsx({ t, rows }) {
  const wb = XLSX.utils.book_new();
  const data = [
    [t.app.date, `${t.app.income}/${t.app.expense}`, t.app.category, t.app.description, t.app.cari, t.app.bank, t.app.amount],
    ...rows.map((r) => [
      r.date,
      r.type === "income" ? t.app.income : t.app.expense,
      r.category,
      r.description || "",
      r.cari_name || "",
      r.bank_account_name || "",
      r.amount,
    ]),
  ];
  const ws = XLSX.utils.aoa_to_sheet(data);
  ws["!cols"] = [{ wch: 12 }, { wch: 10 }, { wch: 18 }, { wch: 34 }, { wch: 24 }, { wch: 22 }, { wch: 12 }];
  XLSX.utils.book_append_sheet(wb, ws, t.app.transactions.slice(0, 31));
  XLSX.writeFile(wb, `ira-finans-hareketler-${new Date().toISOString().slice(0, 10)}.xlsx`);
}
